<template>
  <div id="booking-widget">
    <div v-show="propertyerror">
      <div class="container">
        <div class="alert alert-danger">
          <strong>Invalid property id {{ propertyid }}.</strong> Please contact
          <a href="mailto:info@reserveport.com">info@reserveport.com.</a>
        </div>
      </div>
    </div>
    <div class="reserveport-form-wrap" v-if="!propertyerror">
      <div class="container vue-content-body">
        <div class="hbf">
          <div class="inner">
            <!-- search bar improved -->
            <div class="d-flex justify-content-between">
              <h3>
                Check Availability
                <span v-if="loadResult"><small style="font-weight: 200" v-show="spinner">({{ bookingData.name
                    }})</small></span>
              </h3>
              <button id="vue-btn-managebooking" data-toggle="modal" data-target="#modalManageBooking"
                style="color: #000;" class="btn btn-sm mb-3" v-if="bookingData.enable_manage_booking">
                <i class="fa fa-edit pr-1"></i>Manage Booking
              </button>
            </div>

            <div class="vue-search-box" v-show="spinner" v-if="multipropertyStatus == false && clientemail == false">
              <form>
                <div class="row vue-date-box">
                  <div class="col-md-3">
                    <label class="guest-link">Arrival Date</label>
                    <div class="form-group vue-sd-container">
                      <CheckinDate
                        :stayrestrictions="this.bookings.data && this.bookings.data[this.propertyid] ? this.bookings.data[this.propertyid].stay_restrictions : []"
                        @checkin-date-changed="checkAvailabilty('l')"></CheckinDate>
                    </div>
                  </div>
                  <div class="col-md-3 vue-md_p5">
                    <label class="guest-link">Departure Date</label>
                    <div class="form-group vue-sd-container">
                      <CheckoutDate
                        :stayrestrictions="this.bookings.data && this.bookings.data[this.propertyid] ? this.bookings.data[this.propertyid].stay_restrictions : []"
                        @checkout-date-changed="checkAvailabilty('l')"></CheckoutDate>
                    </div>
                  </div>
                  <div class="col-md-3 vue-md_p5">
                    <label class="guest-link">Occupancy</label>

                    <div class="form-group">
                      <div id="vue-guests-groups" class="form-control vue-small_large_select" data-toggle="dropdown"
                        aria-haspopup="true" aria-expanded="false" @click="stickMenu">
                        <div id="occupancy-control" data-toggle="dropdown" aria-haspopup="true" aria-expanded="true">
                          <div id="occupancy-text-2" class="pull-left">
                            <span v-if="room > 1">{{ room }} {{ roomLabel.plural }}
                            </span>
                            <span v-else>{{ room }} {{ roomLabel.singular }} |
                              {{ guest }} Guest</span>
                          </div>
                          <div class="pull-right">
                            <img loading="lazy" src="https://reservations.reserveport.com/static/img/icon.png" alt=""
                              width="15px" />
                          </div>
                        </div>
                        <div id="vue-dropdown-home" class="dropdown-menu vue-paddt15">
                          <div class="vue-mobile pull-left">
                            <div class="row">
                              <div class="col-md-6 col-6">
                                <label>{{ roomLabel.plural }}</label>
                              </div>
                              <div class="col-md-6 col-6">
                                <div class="paddb10 booking-btngrp block">
                                  <button type="button" v-on:click.prevent="removeRoom" class="vue-btnb"
                                    id="minus-vue-btn-roomsfx">
                                    <i class="fa fa-minus"></i>
                                  </button>
                                  <input disabled="disabled" class="vue-fxcount" :value="room" id="roomsfx"
                                    name="roomsfx" type="text" />
                                  <button type="button" v-on:click.prevent="addRoom" class="vue-btnb"
                                    id="plus-vue-btn-roomsfx">
                                    <i class="fa fa-plus"></i>
                                  </button>
                                </div>
                              </div>
                            </div>

                            <div id="vue-occupancy-details" v-if="room == 1">
                              <div class="row">
                                <div class="col-md-6 col-sm-7 col-6">
                                  <label>Adults</label><small class="vue-ageDiv">({{
                                    ageGroupsDetails.adult_age
                                    }}yr+)</small>
                                </div>
                                <div class="col-md-6 col-sm-5 col-6">
                                  <div class="paddb10 booking-btngrp block">
                                    <button type="button" v-on:click.prevent="removeAdult" class="vue-btnb"
                                      id="minus-vue-btn-adultsfx">
                                      <i class="fa fa-minus"></i>
                                    </button>
                                    <input disabled="disabled" class="vue-fxcount" v-model="defaultAdultNo"
                                      id="occ_adult_l" name="adultsfx" type="text" />
                                    <button type="button" v-on:click.prevent="addAdult" class="vue-btnb"
                                      id="plus-vue-btn-adultsfx">
                                      <i class="fa fa-plus"></i>
                                    </button>
                                  </div>
                                </div>
                              </div>
                              <div class="clearfix clear"></div>
                              <div class="row" style="padding-top: 10px; padding-bottom: 10px"
                                v-if="ageGroupsDetails.children_allowed != 0">
                                <div class="col-md-6 col-sm-6 col-6">
                                  <label>Children</label><small class="vue-ageDiv">({{ ageGroupsDetails.child_min_age }}
                                    -
                                    {{
                                    ageGroupsDetails.child_max_age
                                    }}yr)</small>
                                </div>
                                <div class="col-md-6 col-sm-6 col-6">
                                  <div class="paddb10 booking-btngrp block">
                                    <button type="button" v-on:click.prevent="removeChildren" class="vue-btnb"
                                      id="minus-vue-btn-childrenfx">
                                      <i class="fa fa-minus"></i>
                                    </button>
                                    <input disabled="disabled" class="vue-fxcount" v-model="defaultChildrenNo"
                                      id="occ_children_l" name="childrenfx" type="text" />
                                    <button type="button" v-on:click.prevent="addChildren" class="vue-btnb"
                                      id="plus-vue-btn-childrenfx">
                                      <i class="fa fa-plus"></i>
                                    </button>
                                  </div>
                                </div>
                                <div class="col-md-12" v-if="children > 0">
                                  <div id="vue-ageDiv">
                                    <label id="age_label">Please select the child's age. Children
                                      are considered to be between
                                      {{ ageGroupsDetails.child_min_age }} and
                                      {{ ageGroupsDetails.child_max_age }}
                                      years.</label>
                                    <div class="child_div" v-for="child in children" :key="child">
                                      <label>Child {{ child }}</label>
                                      <select id="child_1_age" name="child_1_age" class="child_ages rounded5"
                                        v-on:change="
                                          updateChildAges($event, child)
                                        ">
                                        <option value="">Age</option>
                                        <option v-for="(
                                            childrenagerange, ageindex
                                          ) in computeChildrenAgeRange(
                                            ageGroupsDetails
                                          )" :key="ageindex" :value="childrenagerange.age">
                                          {{ childrenagerange.age }} yrs
                                        </option>
                                      </select>
                                    </div>
                                    <div v-if="ageError" style="color:red">
                                      <small>Please Fill the Child {{child}} Age before adding another child</small>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div class="clearfix clear"></div>
                              <div class="row" v-if="ageGroupsDetails.babies_allowed != 0">
                                <div class="col-md-6 col-sm-6 col-6">
                                  <div v-if="ageGroupsDetails.baby_min_age == ageGroupsDetails.baby_max_age">
                                    <label>Infants</label><small class="vue-ageDiv">({{
                                      ageGroupsDetails.baby_max_age
                                      }}yr only)</small>
                                  </div>
                                  <div v-else>
                                    <label
                                      v-if="ageGroupsDetails.baby_min_age < ageGroupsDetails.baby_max_age">Infants</label><small
                                      class="vue-ageDiv">({{ ageGroupsDetails.baby_min_age }}-{{
                                      ageGroupsDetails.baby_max_age
                                      }}yr)</small>
                                  </div>
                                </div>
                                <div class="col-md-6 col-sm-6 col-6">
                                  <div class="paddb10 booking-btngrp block">
                                    <button type="button" v-on:click.prevent="removeBabies" class="vue-btnb"
                                      id="minus-vue-btn-babiesfx">
                                      <i class="fa fa-minus"></i>
                                    </button>
                                    <input disabled="disabled" class="vue-fxcount" v-model="defaultbabiesNo"
                                      id="occ_babies_l" name="babiesfx" type="text" />
                                    <button type="button" v-on:click.prevent="addBabies" class="vue-btnb"
                                      id="plus-vue-btn-babiesfx">
                                      <i class="fa fa-plus"></i>
                                    </button>
                                  </div>
                                </div>
                              </div>
                            </div>

                            <div v-else class="row-fluid">
                              <div class="col-md-12 col-md-12 col-12">
                                <div id="vue-occupancy-details-text" class="hide">
                                  <div class="alert alert-warning mrgb5 paddtb5" role="alert">
                                    Guest occupancy selection in each
                                    {{ roomLabel.singular }} will be availed on
                                    the search results page.
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="clearfix clear"></div>
                          <div class="col-md-12">
                            <a href="javascript:void(0);" class="pull-right" @click="close"><i class="fa fa-close"></i>
                              Close</a>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <!-- end here -->
                  <div class="col-md-3 col-sm-4 vue-btn-wrap avail-wrap vue-md_p5">
                    <span id="vue-havepromo" class="vue-horizontal" @click="showPromoCode">Have a promotion code?
                    </span>
                    <div id="actPromoCodeact" v-if="showpromo || promo != ''">
                      <input type="text" id="coupon_code_largeScreen" v-model="promo"
                        class="vue-coupon_code_screen vue-horizontal" placeholder="Promo Code" />
                    </div>
                    <!-- <transition name="slide-fade"> -->
                    <!-- </transition> -->
                    <button id="vue-btn-search" v-on:click.prevent="checkAvailabilty('l')"
                      class="btn btn-md btn-orange-solid">
                      <div v-show="isSearching">
                        <span v-html="searchspinner"></span>
                      </div>
                      <div v-show="!isSearching">Check Availability</div>
                    </button>
                  </div>
                </div>
              </form>
            </div>
            <div class="vue-search-box" v-show="spinner" v-else>
              <form>
                <div class="row vue-date-box">
                  <div class="col-md-3" v-if="multipropertyStatus == true">
                    <label>Destination</label>
                    <!-- {{multiproperties}} -->
                    <div class="form-group" id="vue-guests-groups">
                      <select class="form-control vue-email_screen sd vue-destination"
                        @click="updateRoomFilter(multiproperties)" v-model="destination">
                        <option :value="initialPropertyId">{{ initialPropertyName }}</option>
                        <option :value="pdestination.id" v-for="(pdestination, destindex) in multiproperties.filter(p => p.id !== initialPropertyId)"
                          :key="destindex">
                          {{ pdestination.propertyName }}
                        </option>
                      </select>
                    </div>
                  </div>
                  <div class="col-md-2">
                    <label>Arrival Date</label>
                    <div class="form-group vue-sd-container">
                      <CheckinDate
                        :stayrestrictions="this.bookings.data && this.bookings.data[this.propertyid] ? this.bookings.data[this.propertyid].stay_restrictions : []"
                        @checkin-date-changed="checkAvailabilty('l')"></CheckinDate>
                    </div>
                  </div>
                  <div class="col-md-2 vue-md_p5">
                    <label>Departure Date</label>
                    <div class="form-group vue-sd-container">
                      <CheckoutDate
                        :stayrestrictions="this.bookings.data && this.bookings.data[this.propertyid] ? this.bookings.data[this.propertyid].stay_restrictions : []"
                        @checkout-date-changed="checkAvailabilty('l')"></CheckoutDate>
                    </div>
                  </div>
                  <div
                    :class="multipropertyStatus == true && clientemail == true ? 'col-md-2 vue-md_p5' : 'col-md-3 vue-md_p5'">
                    <label class="guest-link">Occupancy</label>

                    <div class="form-group">
                      <div id="vue-guests-groups" class="form-control vue-small_large_select" data-toggle="dropdown"
                        aria-haspopup="true" aria-expanded="false" @click="stickMenu">
                        <div id="occupancy-control" data-toggle="dropdown" aria-haspopup="true" aria-expanded="true">
                          <div id="occupancy-text-2" class="pull-left">
                            <span v-if="room > 1">{{ room }} {{ roomLabel.plural }}
                            </span>
                            <span v-else>{{ room }} {{ roomLabel.singular }} |
                              {{ guest }} Guest</span>
                          </div>
                          <div class="pull-right">
                            <img src="https://reservations.reserveport.com/static/img/icon.png" alt="" loading="lazy"
                              width="15px" />
                          </div>
                        </div>
                        <div id="vue-dropdown-home" class="dropdown-menu vue-paddt15">
                          <div class="vue-mobile pull-left">
                            <div class="row">
                              <div class="col-md-6 col-6">
                                <label>{{ roomLabel.plural }}</label>
                              </div>
                              <div class="col-md-6 col-6">
                                <div class="paddb10 booking-btngrp block">
                                  <button type="button" v-on:click.prevent="removeRoom" class="vue-btnb"
                                    id="minus-vue-btn-roomsfx">
                                    <i class="fa fa-minus"></i>
                                  </button>
                                  <input disabled="disabled" class="vue-fxcount" :value="room" id="roomsfx"
                                    name="roomsfx" type="text" />
                                  <button type="button" v-on:click.prevent="addRoom" class="vue-btnb"
                                    id="plus-vue-btn-roomsfx">
                                    <i class="fa fa-plus"></i>
                                  </button>
                                </div>
                              </div>
                            </div>

                            <div id="vue-occupancy-details" v-if="room == 1">
                              <div class="row">
                                <div class="col-md-6 col-sm-7 col-6">
                                  <label>Adults</label><small class="vue-ageDiv">({{
                                    ageGroupsDetails.adult_age
                                    }}yr+)</small>
                                </div>
                                <div class="col-md-6 col-sm-5 col-6">
                                  <div class="paddb10 booking-btngrp block">
                                    <button type="button" v-on:click.prevent="removeAdult" class="vue-btnb"
                                      id="minus-vue-btn-adultsfx">
                                      <i class="fa fa-minus"></i>
                                    </button>
                                    <input disabled="disabled" class="vue-fxcount" v-model="defaultAdultNo"
                                      id="occ_adult_l" name="adultsfx" type="text" />
                                    <button type="button" v-on:click.prevent="addAdult" class="vue-btnb"
                                      id="plus-vue-btn-adultsfx">
                                      <i class="fa fa-plus"></i>
                                    </button>
                                  </div>
                                </div>
                              </div>
                              <div class="clearfix clear"></div>
                              <div class="row" style="padding-top: 10px; padding-bottom: 10px"
                                v-if="ageGroupsDetails.children_allowed != 0">
                                <div class="col-md-6 col-sm-6 col-6">
                                  <label>Children</label><small class="vue-ageDiv">({{ ageGroupsDetails.child_min_age }}
                                    -
                                    {{
                                    ageGroupsDetails.child_max_age
                                    }}yr)</small>
                                </div>
                                <div class="col-md-6 col-sm-6 col-6">
                                  <div class="paddb10 booking-btngrp block">
                                    <button type="button" v-on:click.prevent="removeChildren" class="vue-btnb"
                                      id="minus-vue-btn-childrenfx">
                                      <i class="fa fa-minus"></i>
                                    </button>
                                    <input disabled="disabled" class="vue-fxcount" v-model="defaultChildrenNo"
                                      id="occ_children_l" name="childrenfx" type="text" />
                                    <button type="button" v-on:click.prevent="addChildren" class="vue-btnb"
                                      id="plus-vue-btn-childrenfx">
                                      <i class="fa fa-plus"></i>
                                    </button>
                                  </div>
                                </div>
                                <div class="col-md-12" v-if="children > 0">
                                  <div id="vue-ageDiv">
                                    <label id="age_label">Please select the child's age. Children
                                      are considered to be between
                                      {{ ageGroupsDetails.child_min_age }} and
                                      {{ ageGroupsDetails.child_max_age }}
                                      years.</label>
                                    <div class="child_div" v-for="child in children" :key="child">
                                      <label>Child {{ child }}</label>
                                      <select id="child_1_age" name="child_1_age" class="child_ages rounded5"
                                        v-on:change="
                                          updateChildAges($event, child)
                                        ">
                                        <option value="">Age</option>
                                        <option v-for="(
                                            childrenagerange, ageindex
                                          ) in computeChildrenAgeRange(
                                            ageGroupsDetails
                                          )" :key="ageindex" :value="childrenagerange.age">
                                          {{ childrenagerange.age }} yrs
                                        </option>
                                      </select>
                                    </div>
                                    <div v-if="ageError" style="color:red">
                                      <small>Please Fill the Child {{child}} Age before adding another child</small>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div class="clearfix clear"></div>
                              <div class="row" v-if="ageGroupsDetails.babies_allowed != 0">
                                <div class="col-md-6 col-sm-6 col-6">
                                  <div v-if="ageGroupsDetails.baby_min_age == ageGroupsDetails.baby_max_age">
                                    <label>Infants</label><small class="vue-ageDiv">({{
                                      ageGroupsDetails.baby_max_age
                                      }}yr only)</small>
                                  </div>
                                  <div v-else>
                                    <label
                                      v-if="ageGroupsDetails.baby_min_age < ageGroupsDetails.baby_max_age">Infants</label><small
                                      class="vue-ageDiv">({{ ageGroupsDetails.baby_min_age }}-{{
                                      ageGroupsDetails.baby_max_age
                                      }}yr)</small>
                                  </div>
                                </div>
                                <div class="col-md-6 col-sm-6 col-6">
                                  <div class="paddb10 booking-btngrp block">
                                    <button type="button" v-on:click.prevent="removeBabies" class="vue-btnb"
                                      id="minus-vue-btn-babiesfx">
                                      <i class="fa fa-minus"></i>
                                    </button>
                                    <input disabled="disabled" class="vue-fxcount" v-model="defaultbabiesNo"
                                      id="occ_babies_l" name="babiesfx" type="text" />
                                    <button type="button" v-on:click.prevent="addBabies" class="vue-btnb"
                                      id="plus-vue-btn-babiesfx">
                                      <i class="fa fa-plus"></i>
                                    </button>
                                  </div>
                                </div>
                              </div>
                            </div>

                            <div v-else class="row-fluid">
                              <div class="col-md-12 col-md-12 col-12">
                                <div id="vue-occupancy-details-text" class="hide">
                                  <div class="alert alert-warning mrgb5 paddtb5" role="alert">
                                    Guest occupancy selection in each
                                    {{ roomLabel.singular }} will be availed on
                                    the search results page.
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="clearfix clear"></div>
                          <div class="col-md-12">
                            <a href="javascript:void(0);" class="pull-right" @click="close"><i class="fa fa-close"></i>
                              Close</a>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <!-- <div class="col-md-2" v-if="multipropertyStatus == true">
                   <label>Select Room Type</label>
                    <div class="form-group" id="guests-group">
                      <select class="vue-email_screen sd"  v-model="roomType">
                        <option value="">All</option>
                        <option :value="roomtype.id" v-for="(roomtype, rtypeindex) in filteredRoomTypeArray.roomTypes" :key="rtypeindex">{{roomtype.name}}</option>
                      </select>
                    </div>
                </div> -->
                  <div class="col-md-2 vue-md_p5" v-if="clientemail">
                    <label>Email</label>
                    <div class="form-group">
                      <input id="coupon_code_largeScreen" class="vue-email_screen" v-model="email" type="email"
                        placeholder="Email address" />
                    </div>
                  </div>
                  <!-- end here -->
                  <div class="col-md-2 col-sm-4 vue-btn-wrap avail-wrap vue-md_p5">
                    <span id="vue-havepromo" class="vue-horizontal" @click="showPromoCode">Add promo code
                    </span>
                    <div id="actPromoCodeact" v-if="showpromo || promo != ''">
                      <input type="text" id="coupon_code_largeScreen" v-model="promo"
                        class="vue-coupon_code_screen vue-horizontal" placeholder="Promo Code" />
                    </div>
                    <!-- <transition name="slide-fade"> -->
                    <!-- </transition> -->
                    <button id="vue-btn-search" v-on:click.prevent="checkAvailabilty('l')"
                      class="btn btn-md btn-orange-solid">
                      <div v-show="isSearching">
                        <span v-html="searchspinner"></span>
                      </div>
                      <div v-show="!isSearching">Check Availability</div>
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div style="top: 0;" class="d-block d-md-none" v-if="bookingData.enable_manage_booking">
      <button id="vue-btn-managebooking-mobile" data-toggle="modal" data-target="#modalManageBooking" class="btn w-100"
        style="background: #898989;">Manage Existing Booking</button>
    </div>
    <div class="container bv-example-row room-list vue-content-body" v-if="!propertyerror">
      <!-- search for small devices: rendered via MobileSearchModal, teleported to <body> in mounted() -->
      <!-- endsearch for small devices -->
      <!-- end searchbar -->
      <div class="row" v-show="spinner" v-if="residenceTab == false || bookingData.has_non_refundable_rates">
        <div class="col-md-12 col-sm-12 col-12">
          <div class="residencydiv">
            <div class="vue-btn-group pull-left" id="vue-toggle_residency" v-if="residenceTab == false">
              <button type="button" id="btnres" class="res_vue-btn vue-btn-res vue-btn btn active"
                @click.prevent="localResident()">
                Resident
              </button>
              <button type="button" id="btnnonres" class="nonres_vue-btn vue-btn-non-res btn vue-btn"
                @click.prevent="nonResident()">
                Non-Resident
              </button>
            </div>
            <div v-if="bookingData.has_non_refundable_rates" class="d-flex"
              :class="[residenceTab == false ? 'justify-content-end' : 'justify-content-start']">
              <div class="pull-left">
                <select class="form-control rounded-0" v-model="nonRefundable" @change="checkAvailabilty('l')">
                  <option value="false" selected>Normal Prices</option>
                  <option value="true">Non-Refundable Prices</option>
                </select>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row mb-4" v-if="guestFormSettings.proof_of_residency_selection == 1 && proof">
        <div class="col-md-12 col-sm-12 col-12">
          <div id="proof">
            <transition name="slide-fade">
              <span class="pull-right">Proof of residency will be required upon check-in.</span>
            </transition>
          </div>
        </div>
      </div>
      <!-- body -->
      <div class="row" v-if="!errors">
        <div class="col-md-9 col-sm-12 col-12">
          <div class="row">
            <div class="act-overlay" v-show="!spinner">
              <loader-terms></loader-terms>
            </div>
          </div>
          <div class="vue-card-unit" v-for="(booking, bindex) in orderedRooms" :key="bindex" v-show="spinner">
            <div class="vue-card-unit-title"
              @click.prevent="gotoRoomDetail(booking.id, booking.availability.available, booking.availability.allowOnlineBookings ==1, booking)">
              <h1 class="room-title" style="cursor: pointer">{{
                booking.name
                }}</h1><span style="color: #bd362f" v-if="booking.availability.available == 0">(SOLD OUT)</span>
              <span v-if="booking.lastBooked !== ''" class="availability_text">{{ booking.lastBooked }}</span>
            </div>
            <div>
              <div class="row">
                <div class="col-md-4 col-sm-12 col-12">
                  <div class="room-thumb" v-if="booking.images && booking.images.length">
                    <div class="room-thumb-track"
                      :style="{ transform: 'translateX(-' + ((roomImageIndex[bindex] || 0) * 100) + '%)' }">
                      <img v-for="(img, imgIndex) in booking.images" :key="imgIndex" :src="img" :alt="booking.name"
                        class="room-thumb-img" />
                    </div>
                    <template v-if="booking.images.length > 1">
                      <button type="button" class="room-thumb-nav room-thumb-nav-prev"
                        @click.prevent="changeRoomImage(bindex, booking.images.length, -1)" aria-label="Previous image">
                        <i class="fa fa-angle-left"></i>
                      </button>
                      <button type="button" class="room-thumb-nav room-thumb-nav-next"
                        @click.prevent="changeRoomImage(bindex, booking.images.length, 1)" aria-label="Next image">
                        <i class="fa fa-angle-right"></i>
                      </button>
                      <span class="room-thumb-counter">{{ (roomImageIndex[bindex] || 0) + 1 }}/{{ booking.images.length }}</span>
                    </template>
                  </div>
                  <div class="room-thumb" v-else>
                    <img src="https://reservations.reserveport.com/offers/static/img/noimages.jpg" :alt="booking.name"
                      class="room-thumb-img" />
                  </div>
                </div>
                <div class="col-md-8 col-sm-12 col-12">
                  <div v-if="booking.availability.allowOnlineBookings == 1">
                    <div v-for="board in booking.boards" :key="board.name" class="vue-pad-content">
                      <div v-if="
                        (bookingData.currency.res != '' &&
                          board.roomPrice.res != 0) ||
                        (bookingData.currency.nonres != '' &&
                          board.roomPrice.nonres != 0)
                      ">
                        <div class="vue-border-btm padtb-1rem">
                          <div class="row">
                            <div class="col-md-4 col-sm-3 col-7">
                              <span class="text-center-sm text-center-xs">
                                <i class="fa fa-check"></i>
                                <strong> {{ board.name }}</strong>
                              </span>
                              <div>
                                <i class="small">{{ board.description }}</i>
                              </div>
                            </div>
                            <div class="col-md-2 col-sm-2 col-5">
                              <span v-for="n in adult" :key="n">
                                <i class="fa fa-user" style="font-size: 14px"></i>
                              </span>
                              <span v-if="children > 0">
                                <span v-for="d in children" :key="d">
                                  <i class="fa fa-user" style="font-size: 10px"></i>
                                </span>
                              </span>
                            </div>
                            <div class="col-md-3 col-sm-3 col-6" v-if="booking.availability.available !== 0"
                              id="priceDetail">
                              <!-- resident -->
                              <div v-if="proofRes == 0">
                                <div v-if="board.roomDiscount.res == 0">
                                  <strong>{{ bookingData.currency.res }}
                                    {{
                                    formatPrice(board.roomPrice.res)
                                    }} </strong><br />
                                </div>
                                <div v-else>
                                  <small>
                                    <strong>
                                      <strike style="color: #a81414">{{ bookingData.currency.res }} &nbsp;
                                        {{ formatPrice(board.roomPrice.res) }}
                                      </strike>
                                    </strong>
                                  </small>
                                  <br />
                                  <strong>{{ bookingData.currency.res }} &nbsp;
                                    {{
                                    formatPrice(
                                    board.roomPriceAfterDiscount.res
                                    )
                                    }}</strong><br />
                                </div>
                              </div>
                              <!-- endresident -->
                              <!-- non resident -->
                              <div v-if="proofRes == 1">
                                <div v-if="board.roomDiscount.nonres == 0">
                                  <strong>{{ bookingData.currency.nonres }}
                                    {{
                                    formatPrice(board.roomPrice.nonres)
                                    }} </strong><br />
                                </div>
                                <div v-else>
                                  <small>
                                    <strong>
                                      <strike style="color: #a81414">{{ bookingData.currency.nonres }}
                                        &nbsp;
                                        {{
                                        formatPrice(board.roomPrice.nonres)
                                        }}
                                      </strike>
                                    </strong> </small><br />
                                  <strong>{{ bookingData.currency.nonres }} &nbsp;
                                    {{
                                    formatPrice(
                                    board.roomPriceAfterDiscount.nonres
                                    )
                                    }}</strong><br />
                                </div>
                              </div>
                              <!-- end resident -->
                              <span class="small">
                                <strong>for {{ period }} {{ periodText }} </strong>
                                <span v-if="board.extraNights && board.extraNights[resNonRes] !== 0">and <strong><br />
                                    {{ board.extraNights[resNonRes] }} extra night(s)</strong> free</span>
                                <span v-if="board.freeNights && board.freeNights[resNonRes] !== 0">with <strong><br />
                                    {{ board.freeNights[resNonRes] }} free night(s)</strong> applied</span>
                              </span>
                              <span class="small"><br />{{ bookingData.vat.room_price }} of taxes</span>
                            </div>
                            <div class="col-md-3 col-sm-3 col-6" v-if="
                              bookingData.guest_form_settings
                                .proof_of_residency_popup == 0 &&
                              booking.availability.available !== 0
                            ">
                              <button class="btn btn-orange-solid" id="vue-btn" :disabled="clicked" @click.prevent="
                                redirectToBookDetail(booking, board)
                              " :data-toggle="dataToggle" data-placement="top" :title="errMsg">
                                Book Now
                              </button>
                            </div>
                            <div class="col-md-3 col-sm-3 col-6" v-if="
                              bookingData.guest_form_settings
                                .proof_of_residency_popup == 1 &&
                              booking.availability.available !== 0
                            ">
                              <button data-toggle="modal" data-target="#proffmodalpopup" id="vue-btn"
                                :disabled="clicked" class="btn btn-orange-solid" v-if="resident == 'resident'"
                                @click="openProofModal(booking, board)">
                                Book Now
                              </button>
                              <button id="vue-btn" class="btn btn-orange-solid" @click.prevent="
                                redirectToBookDetail(booking, board)
                              " v-if="resident == 'non-resident'" :disabled="clicked" :data-toggle="dataToggle"
                                data-placement="top" :title="errMsg">
                                Book Now
                              </button>
                            </div>
                            <div class="col-md-6 col-sm-3 col-12" v-if="booking.availability.available == 0"
                              id="priceDetail">
                              <!-- resident -->
                              <div v-if="proofRes == 0">
                                <div v-if="board.roomDiscount.res == 0">
                                  <strong>{{ bookingData.currency.res }}
                                    {{
                                    formatPrice(board.roomPrice.res)
                                    }} </strong><br />
                                </div>
                                <div v-else>
                                  <small>
                                    <strong>
                                      <strike style="color: #a81414">{{ bookingData.currency.res }} &nbsp;
                                        {{ formatPrice(board.roomPrice.res) }}
                                      </strike>
                                    </strong>
                                  </small>
                                  <br />
                                  <strong>{{ bookingData.currency.res }} &nbsp;
                                    {{
                                    formatPrice(
                                    board.roomPriceAfterDiscount.res
                                    )
                                    }}</strong><br />
                                </div>
                              </div>
                              <!-- endresident -->
                              <!-- non resident -->
                              <div v-if="proofRes == 1">
                                <div v-if="board.roomDiscount.nonres == 0">
                                  <strong>{{ bookingData.currency.nonres }}
                                    {{
                                    formatPrice(board.roomPrice.nonres)
                                    }} </strong><br />
                                </div>
                                <div v-else>
                                  <small>
                                    <strong>
                                      <strike style="color: #a81414">{{ bookingData.currency.nonres }}
                                        &nbsp;
                                        {{
                                        formatPrice(board.roomPrice.nonres)
                                        }}
                                      </strike>
                                    </strong> </small><br />
                                  <strong>{{ bookingData.currency.nonres }} &nbsp;
                                    {{
                                    formatPrice(
                                    board.roomPriceAfterDiscount.nonres
                                    )
                                    }}</strong><br />
                                </div>
                              </div>
                              <!-- end resident -->
                              <span class="small"><strong>for {{ period }} {{ periodText }}</strong></span><br />
                              <span class="small">{{ bookingData.vat.room_price }} of taxes</span>
                            </div>
                            <!-- modal for proof of residency pop -->
                            <div class="modal fade" id="proffmodalpopup" tabindex="-1" role="dialog" aria-hidden="true">
                              <div class="modal-dialog">
                                <div class="modal-content">
                                  <!-- Modal body -->
                                  <div class="proof_modal_body">
                                    Dear Guest, <br /><br />
                                    <p>
                                      Please note that you have selected
                                      resident rates
                                    </p>
                                    <p>
                                      As per company policies proof of residency
                                      will be required upon check-in
                                    </p>
                                    <div class="proof_modal_list">
                                      <ul>
                                        <li>
                                          If you do confirm that you are a
                                          resident kindly click 'OK' to proceed
                                          with your booking
                                        </li>
                                        <li>
                                          If you are a non-resident, kindly
                                          click 'CANCEL' and use the
                                          resident/non-resident tabs to switch
                                          to the non-resident portal
                                        </li>
                                      </ul>
                                    </div>
                                  </div>

                                  <!-- Modal footer -->
                                  <div class="modal-footer">
                                    <div class="btn-toolbar" role="toolbar" aria-label="Toolbar with button groups">
                                      <div class="btn-group mr-2" role="group" aria-label="Second group">
                                        <button type="button" id="vue-btn" class="btn btn-outline" data-dismiss="modal">
                                          Cancel
                                        </button>
                                      </div>
                                      <div class="btn-group" role="group" aria-label="Third group">
                                        <button type="button" class="btn btn-solid" id="vue-btn" @click.prevent="
                                          redirectToBookDetail(
                                            bookingDataProof,
                                            boardDataProof
                                          )
                                        " data-dismiss="modal">
                                          OK
                                        </button>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <!-- end -->
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <!-- contacts for online not enabled scenario -->
                  <div v-else class="vue-pad-content">
                    <div class="alert alert-warning mrgtb20 paddtb10" role="alert"
                      v-if="booking.availability.available !== 0">
                      <span class="fa fa-bell-o faa-ring animated"></span>
                      Please send an email
                      to
                      <a :href="'mailto:' + bookingData.contactDetails.mainEmail">{{
                        bookingData.contactDetails.mainEmail
                        }}</a>
                      to reserve this room.
                    </div>
                    <div v-for="board in booking.boards" :key="board.name" class="vue-pad-content"
                      v-if="booking.availability.available !== 0 && booking.availability.allowOnlineBookings == 2">
                      <div v-if="(bookingData.currency.res != '' &&
                                              board.roomPrice.res != 0) ||
                                              (bookingData.currency.nonres != '' &&
                                                board.roomPrice.nonres != 0)
                                              ">
                        <div class="vue-border-btm padtb-1rem">
                          <div class="row">
                            <div class="col-md-5 col-sm-3 col-7">
                              <span class="text-center-sm text-center-xs">
                                <i class="fa fa-check"></i>
                                <strong> {{ board.name }}</strong>
                              </span>
                              <div>
                                <i class="small">{{ board.description }}</i>
                              </div>
                            </div>
                            <div class="col-md-3 col-sm-2 col-5">
                              <span v-for="n in adult" :key="n">
                                <i class="fa fa-user" style="font-size: 14px"></i>
                              </span>
                              <span v-if="children > 0">
                                <span v-for="d in children" :key="d">
                                  <i class="fa fa-user" style="font-size: 10px"></i>
                                </span>
                              </span>
                            </div>
                            <div class="col-md-3 col-sm-3 col-6" v-if="booking.availability.available !== 0"
                              id="priceDetail">
                              <!-- resident -->
                              <div v-if="proofRes == 0">
                                <div v-if="board.roomDiscount.res == 0">
                                  <strong>{{ bookingData.currency.res }}
                                    {{
                                    formatPrice(board.roomPrice.res)
                                    }} </strong><br />
                                </div>
                                <div v-else>
                                  <small>
                                    <strong>
                                      <strike style="color: #a81414">{{ bookingData.currency.res }} &nbsp;
                                        {{ formatPrice(board.roomPrice.res) }}
                                      </strike>
                                    </strong>
                                  </small>
                                  <br />
                                  <strong>{{ bookingData.currency.res }} &nbsp;
                                    {{
                                    formatPrice(
                                    board.roomPriceAfterDiscount.res
                                    )
                                    }}</strong><br />
                                </div>
                              </div>
                              <!-- endresident -->
                              <!-- non resident -->
                              <div v-if="proofRes == 1">
                                <div v-if="board.roomDiscount.nonres == 0">
                                  <strong>{{ bookingData.currency.nonres }}
                                    {{
                                    formatPrice(board.roomPrice.nonres)
                                    }} </strong><br />
                                </div>
                                <div v-else>
                                  <small>
                                    <strong>
                                      <strike style="color: #a81414">{{ bookingData.currency.nonres }}
                                        &nbsp;
                                        {{
                                        formatPrice(board.roomPrice.nonres)
                                        }}
                                      </strike>
                                    </strong> </small><br />
                                  <strong>{{ bookingData.currency.nonres }} &nbsp;
                                    {{
                                    formatPrice(
                                    board.roomPriceAfterDiscount.nonres
                                    )
                                    }}</strong><br />
                                </div>
                              </div>
                              <!-- end resident -->
                              <span class="small">
                                <strong>for {{ period }} {{ periodText }} </strong>
                                <span v-if="board.extraNights && board.extraNights[resNonRes] !== 0">and <strong><br />
                                    {{ board.extraNights[resNonRes] }} extra night(s)</strong> free</span>
                                <span v-if="board.freeNights && board.freeNights[resNonRes] !== 0">with <strong><br />
                                    {{ board.freeNights[resNonRes] }} free night(s)</strong> applied</span>
                              </span>
                              <span class="small"><br />{{ bookingData.vat.room_price }} of taxes</span>
                            </div>
                            <div class="col-md-6 col-sm-3 col-12" v-if="booking.availability.available == 0"
                              id="priceDetail">
                              <!-- resident -->
                              <div v-if="proofRes == 0">
                                <div v-if="board.roomDiscount.res == 0">
                                  <strong>{{ bookingData.currency.res }}
                                    {{
                                    formatPrice(board.roomPrice.res)
                                    }} </strong><br />
                                </div>
                                <div v-else>
                                  <small>
                                    <strong>
                                      <strike style="color: #a81414">{{ bookingData.currency.res }} &nbsp;
                                        {{ formatPrice(board.roomPrice.res) }}
                                      </strike>
                                    </strong>
                                  </small>
                                  <br />
                                  <strong>{{ bookingData.currency.res }} &nbsp;
                                    {{
                                    formatPrice(
                                    board.roomPriceAfterDiscount.res
                                    )
                                    }}</strong><br />
                                </div>
                              </div>
                              <!-- endresident -->
                              <!-- non resident -->
                              <div v-if="proofRes == 1">
                                <div v-if="board.roomDiscount.nonres == 0">
                                  <strong>{{ bookingData.currency.nonres }}
                                    {{
                                    formatPrice(board.roomPrice.nonres)
                                    }} </strong><br />
                                </div>
                                <div v-else>
                                  <small>
                                    <strong>
                                      <strike style="color: #a81414">{{ bookingData.currency.nonres }}
                                        &nbsp;
                                        {{
                                        formatPrice(board.roomPrice.nonres)
                                        }}
                                      </strike>
                                    </strong> </small><br />
                                  <strong>{{ bookingData.currency.nonres }} &nbsp;
                                    {{
                                    formatPrice(
                                    board.roomPriceAfterDiscount.nonres
                                    )
                                    }}</strong><br />
                                </div>
                              </div>
                              <!-- end resident -->
                              <span class="small"><strong>for {{ period }} {{ periodText }}</strong></span><br />
                              <span class="small">{{ bookingData.vat.room_price }} of taxes</span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="vue-card-unit-summary">
                    <div class="row">
                      <div class="col-md-12">
                        <ul class="vue-mrg0">
                          <li class="mrgb10" v-if="booking.availability.available == 0">
                            <div class="soldoutdates">
                              <label class="soldout-lbl">Sold Out on</label>
                              <div v-for="(soldoutdate, soldindex) in booking
                              .availability.soldOutDates" :key="soldindex" style="display: inline">
                                <span class="soldoutspan">{{
                                  soldoutdate
                                  }}</span>
                              </div>
                            </div>
                          </li>
                          <li class="mrgb10" v-if="
                            Object.keys(booking.discount_coupons).length !== 0
                          ">
                            <div class="row pecialoffer">
                              <div class="col-md-12" v-for="(
                                  bdiscount, bindex
                                ) in booking.discount_coupons" :key="bindex">
                                <i class="fa fa-tag"></i><span> {{ bdiscount.code }}</span><br />
                                <small><strong>Applicable Boards:</strong>
                                  <span>{{ bdiscount.boards }}</span> </small><br /><small>
                                  <strong>Coupon Code: </strong>
                                  {{ bdiscount.code }}</small><br /><small>
                                  <strong>Applicable dates: </strong>
                                  {{ bdiscount.start_date }} To
                                  {{ bdiscount.end_date }}</small><br /><small>
                                  <strong>Promo Type: </strong>
                                  {{ bdiscount.type }}</small>
                              </div>
                            </div>
                          </li>
                          <li class="mrgb10">
                            <div class="row availablityroomdetail" v-if="
                              booking.availability.allowOnlineBookings == 1
                            ">
                              <div class="col-md-12">
                                <div v-if="
                                  booking.availability.available <=
                                  booking.availability.alertLimit &&
                                  booking.availability.available > 0
                                ">
                                  <span style="color: #cc0000"><span v-if="booking.availability.available > 1">{{
                                      booking.availability.available
                                      }}
                                      {{ roomLabel.plural }}</span>
                                    <span v-else>
                                      Only {{ booking.availability.available }}
                                      {{ roomLabel.singular }}</span>
                                    like this left in our property</span>
                                </div>
                              </div>
                            </div>
                          </li>
                          <li class="mrgb10">
                            <span><b>Number of adults</b></span>: {{ booking.occupancy.maximumAdultOccupancy }} Max
                          </li>

                          <li class="mrgb10">
                            <span><b>Number of children</b></span>: {{ booking.occupancy.maximumChildOnlyOccupancy }}
                            Max (Own Room) | {{booking.occupancy.maximumChildSharingOccupancy}} Max (Sharing)
                          </li>

                          <li class="mrgb10">
                            <span v-if="ageGroupsDetails.babies_allowed != 0"><strong>Infants: </strong>{{
                              ageGroupsDetails.baby_max_age }}
                              years and below |
                            </span>
                            <span v-if="ageGroupsDetails.children_allowed != 0"><strong>Children: </strong>{{
                              ageGroupsDetails.child_min_age
                              }} -
                              {{ ageGroupsDetails.child_max_age }} years |
                            </span>
                            <span><strong>Adult: </strong>
                              {{ ageGroupsDetails.adult_age }} years and above
                            </span>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                  <div class="clear clearfix"></div>
                  <div class="vue-card-unit-footer">
                    <div class="row">
                      <div class="col-md-12">
                        <span class="uppercase vue-show-details" id="vue-show-details-1410"
                          v-if="booking.description !== ''" @click="rdetail(booking.id)">{{ roomLabel.singular }}
                          details
                        </span>
                        <span class="sep" v-if="
                          bookingData.description !== '' &&
                          bookingData.terms !== ''
                        ">|</span>
                        <span id="vue-show-tc-1410" href="#" v-if="bookingData.terms !== ''"
                          class="uppercase vue-show-tc" @click="termCondition(booking.id)">Terms and conditions</span>
                        <span class="sep" v-if="
                          (bookingData.cancellation_policies !== '' &&
                            bookingData.terms !== '') ||
                          (bookingData.description !== '' &&
                            bookingData.terms !== '')
                        ">|</span>
                        <span id="vue-show-tc-1410" v-if="bookingData.cancellation_policies !== ''" href="#"
                          class="uppercase vue-show-tc canc" @click="cancPolicy(booking.id)">Cancellation
                          policies</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!--child-->
            <div class="row">
              <div class="col-md-12 col-sm-12 col-12">
                <transition name="slide-fade">
                  <div class="vue-card-unit-description" v-if="descr == booking.id">
                    <span class="uppercase"><strong> {{ roomLabel.singular }} Details</strong></span>
                    <div v-html="booking.description"></div>

                    <ul class="vue-features-list">
                      <li class="feat vue-non-icons" v-for="(feature, index) in booking.features" :key="index">
                        <i class="fa fa-check"></i> {{ feature.name }}
                      </li>
                    </ul>

                  </div>
                  <div class="vue-card-unit-description" v-if="term == booking.id">
                    <span class="uppercase"><strong>Terms and conditions</strong></span>
                    <div v-html="bookingData.terms"></div>
                  </div>
                  <div class="vue-card-unit-description" v-if="canc == booking.id">
                    <span class="uppercase"><strong> Cancellation Policies</strong></span>
                    <div v-html="bookingData.cancellation_policies"></div>
                  </div>
                </transition>
              </div>
            </div>
            <!-- break is here -->
          </div>
        </div>

        <div class="col-md-3 col-sm-12 col-12" v-show="spinner">
          <div class="vue-right-side">
            <div class="row">
              <div class="col-md-12">
                <div class="vue-side_top_card">
                  <h3>
                    {{ bookingData.name }}
                  </h3>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-12">
                <div class="vue-side_bottom_card">
                  <h3>SUMMARY</h3>
                  <!-- <i class="fa fa-bed fa-4x"></i> -->
                  <div>
                    <div id="no_room_selected" class="no-roomdiv vue-block">
                      <img id="no_room_selected_img" loading="lazy"
                        :src="'https://reservations.reserveport.com/static/img/bed.png'" width="90" />
                      <h4 id="no-rooms">
                        No {{ roomLabel.singular }} Selected
                      </h4>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="row" v-if="paginatedData.length > 0" v-show="bookingData.show_coupon_ads == 1">
              <div class="col-md-12">
                <div class="vue-offers-card">
                  <div class="vue-card slide" v-for="(soffer, sindex) in paginatedData" :key="sindex">
                    <img class="card-img-top vue-responsive" style="cursor: pointer" loading="lazy" @click="submitOffer"
                      :src="soffer.image ? soffer.image : 'https://reservations.reserveport.com/offers/static/img/noimages.jpg'"
                      alt="Card image" />
                    <div class="vue-offers-card-body">
                      <h4 class="card-title" style="cursor: pointer" @click="submitOffer">
                        {{ soffer.couponCode }}
                      </h4>
                      <div v-if="soffer.type == 'rateoveride'">
                        <small class="startingfrom">Price starts from </small>
                        <div v-if="
                          soffer.currencyRes != 0 && soffer.currencyRes != ''
                        " class="rates">
                          <span v-if="soffer.adultRate.res > 0"><strong>{{ soffer.currencyRes }}
                              {{ soffer.adultRate.res }}</strong></span>
                          <span v-else><strong>{{ soffer.currencyRes }}
                              {{ soffer.childRate.res }}</strong></span>
                        </div>
                        <div v-else>
                          <span v-if="soffer.adultRate.nonres > 0"><strong>{{ soffer.currencyNonRes }}
                              {{ soffer.adultRate.nonres }}</strong></span>
                          <span v-else><strong>{{ soffer.currencyNonRes }}
                              {{ soffer.childRate.nonres }}</strong></span>
                        </div>
                      </div>
                      <div v-if="soffer.type == 'discount_percentage'">
                        <small class="startingfrom">Discount </small>
                        <span><strong>{{ soffer.discountRes }} %</strong></span>
                      </div>
                      <div v-if="soffer.type == 'discount_flatrate'">
                        <small class="startingfrom">Discount </small>
                        <div v-if="
                          soffer.currencyRes != 0 && soffer.currencyRes != ''
                        " class="rates">
                          <span><strong>{{ soffer.currencyRes }}
                              {{ soffer.discountRes }}</strong></span>
                        </div>
                        <div v-else class="rates">
                          <span><strong>{{ soffer.currencyNonRes }}
                              {{ soffer.discountNonRes }}</strong></span>
                        </div>
                      </div>
                      <div></div>
                      <br />
                      <!-- <small>{{soffer.propertyName}}</small> -->
                      <!-- <h5>September 18-20, 2017</h5> -->
                      <!-- <p class="card-text" v-html="soffer.introText"></p> -->
                      <form :action="soffer.embedLink" method="get" id="vueofferForm">
                        <input type="hidden" name="pid" :value="soffer.propertyId" />
                        <input type="hidden" name="checkin_date" :value="getCheckinDate(soffer.startDate)" />
                        <input type="hidden" name="checkout_date" :value="
                          getCheckoutDate(soffer.startDate, soffer.minNights)
                        " />
                        <input type="hidden" name="adults" value="1" />
                        <input type="hidden" :value="soffer.couponCode" name="coupon_code" />
                        <button type="submit" class="btn btn-orange-solid" style="margin-top: auto">
                          Book Now
                        </button>
                      </form>
                    </div>
                  </div>
                  <div class="section-content" v-if="pageCount > 1" style="text-align: right">
                    <span @click="prevPage" style="margin-right: 15px; cursor: pointer"><i
                        class="fa fa-angle-left"></i></span>
                    <span>{{ currentPage }} / {{ pageCount }}</span>
                    <span @click="nextPage" style="margin-left: 15px; cursor: pointer"><i
                        class="fa fa-angle-right"></i></span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="container" v-else>
        <div class="alert alert-danger">
          <div v-for="error in errorMsg" :key="error">
            <strong>{{ error }}</strong>
          </div>
        </div>
      </div>

      <!-- Start manage booking modal -->
      <manageBookingModal />
      <!-- End manage booking modal -->

      <!-- endbody -->
    </div>
    <div class="mobile_booking_wrapper">
      <button class="mobile_booking_dates" id="mobile_booking_triger" data-toggle="modal"
        data-target="#modalbookingForm">
        <i class="fa fa-calendar-o mobile_booking_dates_icon" aria-hidden="true"></i>
        <span class="mobile_booking_date_segment">
          <span class="mobile_booking_date_label">Check-in</span>
          <span class="mobile_booking_date_value">{{ mobileCheckinLabel }}</span>
        </span>
        <span class="mobile_booking_date_divider"></span>
        <span class="mobile_booking_date_segment">
          <span class="mobile_booking_date_label">Check-out</span>
          <span class="mobile_booking_date_value">{{ mobileCheckoutLabel }}</span>
        </span>
      </button>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import loader from '../components/loader.vue'
import reusableData from '../components/mixins/reusableData'
import moment from 'moment'
import manageBookingModal from '../components/manageBooking/subcomponents/Modal.vue'
import 'vue2-datepicker/index.css'
import { mapState } from 'vuex'
import CheckinDate from './dates/checkinDate.vue'
import CheckoutDate from './dates/checkoutDate.vue'
import MobileSearchModal from './MobileSearchModal.vue'

export default {
  name: 'Booking',
  props: ['data'],
  components: {
    'loader-terms': loader,
    manageBookingModal,
    CheckinDate, CheckoutDate
  },
  data () {
    return {
      errors: false,
      errorMsg: [],
      residenceTab: false,
      propertyerror: false,
      errormsg: '',
      checkoutdate1: '',
      canc: null,
      checkdate: '',
      consumerKey: '',
      resident: 'resident',
      propertyid: '',
      childAges: [],
      isSearching: false,
      searchspinner: "<i class='fa fa-spinner fa-spin '></i> SEARCHING",
      promoCode: false,
      period: '',
      periodText: 'night',
      spinner: false,
      bookings: this.$store.state.bookings,
      descr: null,
      term: null,
      proof: false,
      clicked: false,
      proofRes: 0,
      resNonRes: 'res',
      guestOccupancy: 1,
      url: null,
      childrenCount: 0,
      destination: '',
      occupancy: '',
      email: '',
      guest: 1,
      room: 1,
      promo: '',
      adult: 1,
      defaultAdultNo: 1,
      defaultChildrenNo: 0,
      defaultbabiesNo: 0,
      babies: 0,
      children: 0,
      roomImageIndex: {},
      bookingDataProof: null,
      boardDataProof: null,
      postdataparamtest: null,
      multiproperties: [],
      filteredRoomTypeArray: '',
      roomType: '',
      initialPropertyId: '',
      initialPropertyName: '',
      multipropertyStatus: false,
      clientemail: false,
      ageGroupsDetails: '',
      bookingData: '',
      guestFormSettings: '',
      roomData: '',
      offers: [],
      currentPage: 1,
      size: 1,
      computedChildAges: [],
      showpromo: false,
      staging: '',
      roomLabel: '',
      chckInDate: '',
      dateChanged: false,
      checkoutDateChanged: false,
      chckOutDate: '',
      unbookableDates: '',
      ageError: false,
      dataToggle: '',
      errMsg: '',
      nonRefundable: false,
      requestCount: 0,
      currentRequestId: ''
    }
  },
  beforeMount: async function () {
    this.resNonRes = this.proofRes === 0 ? 'res' : 'nonres'
    if (this.$root.occupancy !== undefined && this.$root.occupancy !== '') {
      this.adult = parseInt(this.$root.occupancy)
      this.defaultAdultNo = parseInt(this.$root.occupancy)
    }
    // check if coupon code is passed in widget
    if (this.$root.coupon_code !== undefined && this.$root.coupon_code !== '') {
      this.promo = this.$root.coupon_code
    }
    if (this.$root.clientemail === undefined) {
      this.clientemail = false
    } else if (this.$root.clientemail !== '') {
      this.clientemail = this.$root.clientemail
    }
    this.getDateDataFromUrl()
    this.getUrlData()
    this.fetchData()
    // this.multipropertyStatus = this.$root.multiproperty
    if (this.multipropertyStatus === true) {
      this.gettingMultiProperties()
    }
    this.guest = parseInt(this.adult) + parseInt(this.children) + parseInt(this.babies)
    setInterval(() => this.nextPage(), 60000)
    this.destination = this.propertyid
    this.initialPropertyId = String(this.propertyid)
    // console.log('[beforeMount] initialPropertyId set to:', this.initialPropertyId, '| destination:', this.destination)

    this.unbookableDates = {
      disabledDates: {
        to: new Date(this.checkoutdate1) // Disable all dates up to specific date
      }
    }
    const pageAccessedByReload = (
      (window.performance.navigation && window.performance.navigation.type === 1) ||
        window.performance
          .getEntriesByType('navigation')
          .map((nav) => nav.type)
          .includes('reload')
    )
    if (pageAccessedByReload) {
      this.dateChanged = false
    }
    // know the source of the direct booking
    this.getSource()
    // this.dataLoaded = this.bookings.data
  },
  watch: {
    bookingData (val) {
      if (!this.initialPropertyName && val && val.name) {
        this.initialPropertyName = val.name
        // console.log('[watch:bookingData] initialPropertyName captured:', this.initialPropertyName)
      }
    },
    chckInDate () {
      if (this.dateChanged) {
        let nextDate = this.chckInDate// event.target.value
        let stayrestrictions = this.bookings.data[this.propertyid].stay_restrictions
        if (stayrestrictions.length > 0) {
          for (const stayrestriction of stayrestrictions) {
            var startdate = moment(stayrestriction.start_date).subtract(1, 'days').format('YYYY-MM-DD')
            var enddate = moment(stayrestriction.end_date).add(1, 'days').format('YYYY-MM-DD')
            if (moment(this.chckInDate).isBetween(startdate, enddate) === true) {
              var minNights = stayrestriction.minimum_nights
              break
            } else {
              minNights = this.bookings.data[this.propertyid].minimum_nights
            }
          }
        } else {
          minNights = this.bookings.data[this.propertyid].minimum_nights
        }
        let checkoutnextDate = moment(nextDate).add(minNights, 'days').format('YYYY-MM-DD')
        this.chckOutDate = checkoutnextDate
        this.checkoutdate1 = checkoutnextDate
      } else {
        this.dateChanged = true
      }
    }
  },
  methods: {
    selectDate () {
      this.dateChanged = true
    },
    updateRoomFilter (propertyArr) {
      // console.log('[updateRoomFilter] destination:', this.destination, '| propertyid:', this.propertyid)
      // console.log('[updateRoomFilter] multiproperties ids:', propertyArr.map(p => p.id))
      if (this.destination !== '') {
        var arrayFiltered = propertyArr.find(
          (x) => x.id === this.destination.toString()
        )
        // console.log('[updateRoomFilter] matched entry:', arrayFiltered ? { id: arrayFiltered.id, name: arrayFiltered.propertyName } : 'NOT FOUND')
        this.filteredRoomTypeArray = arrayFiltered
      } else {
        // console.log('[updateRoomFilter] skipped — destination is empty')
      }
    },
    disableInput () {
      return false
    },
    disabledRange (date) {
      const mindate = moment(this.checkoutdate1).subtract(1, 'day').format('YYYY-MM-DD')
      return date < new Date(mindate)
    },
    disableDateBeforeToday (date) {
      const todaysDate = moment().subtract(1, 'day').format('YYYY-MM-DD')
      return date < new Date(todaysDate)
    },
    // method to get url parameters
    getDateData () {
      var minimumCheckinNights = this.bookings.data[this.propertyid].minimum_checkin_nights
      var minimumNights = this.bookings.data[this.propertyid].minimum_nights
      if (minimumCheckinNights === 0) {
        var today = moment().format('YYYY-MM-DD')
        var tommorow = minimumNights === 0 ? moment().add(1, 'days').format('YYYY-MM-DD') : moment().add(minimumNights, 'days').format('YYYY-MM-DD')
        this.checkoutdate1 = tommorow
        this.checkdate = today
        this.checkinDate = today
        this.chckInDate = today
        this.checkoutDate = tommorow
        this.chckOutDate = tommorow
      }
      if (minimumCheckinNights > 0) {
        let checkoutRange = minimumCheckinNights + minimumNights
        let futureDate1 = moment().add(minimumCheckinNights, 'days').format('YYYY-MM-DD')
        let nextdate1 = moment().add(checkoutRange, 'days').format('YYYY-MM-DD')
        this.checkoutdate1 = nextdate1
        this.checkdate = futureDate1
        this.chckInDate = futureDate1
        this.checkinDate = futureDate1
        this.checkoutDate = nextdate1
        this.chckOutDate = nextdate1
      }
      // removed the below, reason: non need to update the dates globally
      // const payload2 = {
      //   checkin_date: this.checkinDate,
      //   checkout_date: this.checkoutDate
      // }
      // this.$store.commit('updateDates', payload2)
      this.period = this.calculateStayNights(this.checkinDate, this.checkoutDate);
      this.periodText = this.getPeriodText(this.period)
    },
    updateChildAges (event, index) {
      this.ageError = false
      index = parseInt(index) - 1
      this.childAges[index] = event.target.value
      this.checkAvailabilty()
    },
    stickMenu () {
      var dropdowns = document.getElementsByClassName('dropdown-menu')
      var i
      for (i = 0; i < dropdowns.length; i++) {
        var openDropdown = dropdowns[i]
        if (openDropdown.classList.contains('hidden')) {
          openDropdown.classList.remove('hidden')
        }
      }
      document
        .getElementById('vue-dropdown-home')
        .addEventListener('click', function (event) {
          event.stopPropagation()
        })
      // Closes the menu in the event of outside click
      window.onclick = function (event) {
        if (!event.target.matches('.vue-small_large_select')) {
          var dropdowns = document.getElementsByClassName('dropdown-menu')
          var i
          for (i = 0; i < dropdowns.length; i++) {
            var openDropdown = dropdowns[i]
            if (openDropdown.classList.contains('show')) {
              openDropdown.classList.remove('show')
            }
          }
        }
      }
    },
    openProofModal (booking, board) {
      this.bookingDataProof = booking
      this.boardDataProof = board
    },
    changeRoomImage (bindex, total, direction) {
      const current = this.roomImageIndex[bindex] || 0
      const next = (current + direction + total) % total
      this.$set(this.roomImageIndex, bindex, next)
    },
    showPromoCode () {
      this.showpromo = !this.showpromo
    },
    close () {
      var dropdowns = document.getElementsByClassName('dropdown-menu')
      for (var i = 0; i < dropdowns.length; i++) {
        var openDropdown = dropdowns[i]
        if (openDropdown.classList.contains('show')) {
          openDropdown.classList.remove('show')
        } else {
          openDropdown.classList.add('hidden')
        }
      }
    },
    changeCheckoutDate (event) {
      let nextDate = event.target.value
      let stayrestrictions = this.bookings.data[this.propertyid].stay_restrictions
      if (stayrestrictions.length > 0) {
        for (const stayrestriction of stayrestrictions) {
          var startdate = moment(stayrestriction.start_date).subtract(1, 'days').format('YYYY-MM-DD')
          var enddate = moment(stayrestriction.end_date).add(1, 'days').format('YYYY-MM-DD')
          if (moment(this.chckInDate).isBetween(startdate, enddate) === true) {
            var minNights = stayrestriction.minimum_nights
            break
          } else {
            minNights = this.bookings.data[this.propertyid].minimum_nights
          }
        }
      } else {
        minNights = this.bookings.data[this.propertyid].minimum_nights
      }
      let checkoutnextDate = moment(nextDate).add(minNights, 'days').format('YYYY-MM-DD')
      this.chckOutDate = checkoutnextDate
      this.checkoutdate1 = checkoutnextDate
    },
    addAdult () {
      this.defaultAdultNo = parseInt(this.defaultAdultNo) + 1
      this.guest = this.guest + 1
      this.checkAvailabilty()
    },
    removeAdult () {
      if (this.defaultAdultNo > 1) {
        this.defaultAdultNo = parseInt(this.defaultAdultNo) - 1
        this.guest = this.guest - 1
        this.checkAvailabilty()
      }
    },
    addBabies () {
      this.defaultbabiesNo = parseInt(this.defaultbabiesNo) + 1
      this.guest = this.guest + 1
    },
    removeBabies () {
      if (this.defaultbabiesNo > 0) {
        this.defaultbabiesNo = parseInt(this.defaultbabiesNo) - 1
        this.guest = this.guest - 1
      }
    },
    addChildMobile () {
      this.defaultChildrenNo = parseInt(this.defaultChildrenNo)
      this.childrenCount = this.defaultChildrenNo
      this.children = this.childrenCount
      this.guest = this.guest + 1
    },
    addChildren () {
      if (this.childAges.length === parseInt(this.defaultChildrenNo)) {
        this.defaultChildrenNo = parseInt(this.defaultChildrenNo) + 1
        this.childrenCount = this.defaultChildrenNo
        this.children = this.childrenCount
        this.guest = this.guest + 1
      } else {
        this.ageError = true
      }
    },
    removeChildren () {
      if (this.defaultChildrenNo > 0) {
        // remove child ages if
        this.ageError = false
        this.defaultChildrenNo = parseInt(this.defaultChildrenNo) - 1
        this.childAges.splice(this.defaultChildrenNo, 1)
        this.guest = this.guest - 1
        this.childrenCount = this.defaultChildrenNo
        this.children = this.childrenCount

        this.checkAvailabilty()
      }
    },
    addRoom () {
      ++this.room
    },
    removeRoom () {
      if (this.room !== 1) {
        --this.room
      }
    },
    cancPolicy (bookid) {
      this.canc = this.canc === bookid ? null : bookid
      this.descr = null
      this.term = null
    },
    termCondition (bookid) {
      this.term = this.term === bookid ? null : bookid
      this.descr = null
      this.canc = null
    },
    rdetail (bookid) {
      this.descr = this.descr === bookid ? null : bookid
      this.term = null
      this.canc = null
    },
    boardMatchesRatePlanCode (board) {
      const name = board.name.toLowerCase()
      switch (this.ratePlanBoardCode) {
        case 'BO': return name === 'bed only' || name === 'self catering' || name === 'bed'
        case 'BB': return name === 'bed & breakfast'
        case 'HB': return name === 'half board' || name === 'halfboard'
        case 'FB': return name === 'full board' || name === 'fullboard'
        case 'AI': return name === 'all inclusive'
        default: return true
      }
    },
    // redirectToBookDetail function has been moved
    // to reusableData.js mixin to make it global
    nonResident () {
      this.proof = false
      const btnNonRes = document.getElementById('btnnonres')
      const btnRes = document.getElementById('btnres')
      if (btnNonRes) btnNonRes.classList.add('active')
      if (btnRes) btnRes.classList.remove('active')
      if (
        this.bookings.data[this.propertyid].currency.res !== '' &&
                this.bookings.data[this.propertyid].currency.nonres === ''
      ) {
        this.proofRes = 0
      } else if (
        this.bookings.data[this.propertyid].currency.res === '' &&
                this.bookings.data[this.propertyid].currency.nonres !== ''
      ) {
        this.proofRes = 1
      } else {
        this.proofRes = 1
      }
      this.resident = 'non-resident'
      this.resNonRes = 'nonres'
    },
    localResident () {
      this.proof = true
      this.resident = 'resident'
      this.resNonRes = 'res'
      if (this.bookings.data[this.propertyid].currency.res !== '' && this.bookings.data[this.propertyid].currency.nonres === '') {
        this.proofRes = 0
      } else if (this.bookings.data[this.propertyid].currency.res === '' && this.bookings.data[this.propertyid].currency.nonres !== '') {
        this.proofRes = 1
      } else {
        this.proofRes = 0
      }
      const btnNonRes = document.getElementById('btnnonres')
      const btnRes = document.getElementById('btnres')
      if (btnNonRes) btnNonRes.classList.remove('active')
      if (btnRes) btnRes.classList.add('active')
    },
    // getting offers
    getCheckinDate (date) {
      let today = moment(date).format('YYYY-MM-DD')
      if (today === 'Invalid date') {
        today = moment().format('YYYY-MM-DD')
      } else {
        if (moment(date).isBefore(today) === true) {
          today = moment().format('YYYY-MM-DD')
        }
      }
      return today
    },
    getCheckoutDate (date, minnights) {
      let today = moment(date).format('YYYY-MM-DD')
      if (today === 'Invalid date') {
        today = moment().format('YYYY-MM-DD')
      } else {
        if (moment(date).isBefore(today) === true) {
          today = moment().format('YYYY-MM-DD')
        }
      }
      var tommorow = moment(today).add(minnights, 'days').format('YYYY-MM-DD')
      return tommorow
    },
    nextPage () {
      if (this.currentPage === this.pageCount) {
        this.currentPage = 1
      } else {
        this.currentPage++
      }
    },
    prevPage () {
      if (this.currentPage === 1) {
        this.currentPage = this.pageCount
      } else {
        this.currentPage--
      }
    },
    submitOffer () {
      document.getElementById('vueofferForm').submit()
    },
    // end offers
    async checkAvailabilty (type) {
      // console.log('[checkAvailabilty] START | destination:', this.destination, '| propertyid:', this.propertyid, '| initialPropertyId:', this.initialPropertyId)
      // console.log('[checkAvailabilty] multiproperties ids:', this.multiproperties.map(p => p.id))

      //track request counts
      if (!this.requestCount) this.requestCount = 0
      this.requestCount++

      this.residenceTab = false
      this.errors = false
      this.clicked = true
      this.babies = this.defaultbabiesNo
      this.adult = this.defaultAdultNo
      var roomNo = this.room

      // Current request ID
      const currentRequestId = Date.now()
      this.currentRequestId = currentRequestId

      // validating children ages in mobile search
      if (
        parseInt(this.room) === 1 &&
                parseInt(this.adult) === 0 &&
                parseInt(this.children) === 0
      ) {
        this.room = 1
        this.adult = 1
        this.children = 0
      } else {
        this.adult = parseInt(this.adult)
        this.children = parseInt(this.children)
      }
      this.guest = parseInt(this.adult) + parseInt(this.babies) + parseInt(this.children)
      const payload = {
        roomNo: roomNo,
        promoCode: this.promo,
        proofRes: this.proofRes,
        residency: this.resident
      }
      this.$store.commit('updateRoomNo', payload)
      // test id if no root id is found
      if (this.destination !== '') {
        this.propertyid = this.destination
        console.log('[checkAvailabilty] propertyid set to destination:', this.propertyid)
        console.log('[checkAvailabilty] multiproperties after propertyid update:', this.multiproperties.map(p => ({ id: p.id, name: p.propertyName })))

        const configUrl = process.env.CONFIG_URL['live_url']
        const key = process.env.PMS_KEY['key']
        const config = {
          headers: { 'Accept': 'application/json' }
        }
        const payload = {
          'property_id': this.propertyid,
          'api': this.type
        }
        const configRes = await this.$http.post(configUrl, payload, config)
        if (configRes.status === 200) {
          let configData = this.CryptoJSAesDecrypt(key, configRes.data.property_details)
          configData = JSON.parse(configData)
          const passkey = configData[0].val_ptoken // process.env.SECRET_KEY[this.propertyid].key
          let consumerKey = configData[0].val_reserveport_secret_key // process.env.CONSUMER_KEY[this.propertyid].key
          const details = JSON.parse(configData[0].add_details)
          let fetchUrl = details.url
          if (this.roomType !== '') {
            if (type === 's' || type === 'sa') {
              document.getElementById('btn_close').click()
            }
            this.$router.push({
              path: '/room-details?rid=' +
                                this.roomType +
                                '&pid=' +
                                btoa(this.propertyid)
            })
          }
          var childAgeRange = this.childAges.filter(Boolean)
          const postData = {
            checkin_date: this.checkinDate,
            checkout_date: this.checkoutDate,
            client_email: this.email,
            room: this.room,
            babies: this.babies,
            children: this.children,
            children_ages: childAgeRange,
            adults: this.adult,
            residency: this.resident,
            coupon_code: this.promo,
            isNonRefundable: this.nonRefundable
          }
          var postDataJson = JSON.stringify(postData)
          var encryptedData = this.CryptoJSAesEncrypt(passkey, postDataJson)
          // this.postdataparamtest = encryptedData
          this.isSearching = true
          try {
            const url = `${fetchUrl}/index.php`
            const formData = new FormData()
            formData.append('pid', this.propertyid)
            formData.append('consumer_key', consumerKey)
            formData.append('data', encryptedData)
            formData.append('option', 'com_goreserva_psearch')
            formData.append('task', 'api.searchAvailability')
            const response = await this.axios.post(url, formData)

            //is this still the current request?
            if (this.currentRequestId !== currentRequestId)
            {
              this.requestCount--
              // console.log("Booking::::::::::: Another request is on its way")
              // console.log("Booking::::::::::: Therefore, ignore this")
              return //Ignore response because newer request exists
            }

            if (response) {
              let data = this.CryptoJSAesDecrypt(passkey, response.data.er)
              this.errors = false
              this.errorMsg = []
              if (data !== '') {
                // only close the modal on an explicit "Check Availability" tap ('s'),
                // not on an auto refresh from changing a date ('sa') - keeps the modal
                // open so the user can keep adjusting checkout/guests after a fresh price load
                if (type === 's') {
                  if (parseInt(this.children) !== this.childAges.length) {
                    this.ageError = true
                  } else {
                    document.getElementById('btn_close').click()
                  }
                }
                data = JSON.parse(data)
                let maximumOccupancy = 0
                let maximumAdultOccupancy = 0
                this.period = this.calculateStayNights(this.checkinDate, this.checkoutDate);
                this.periodText = this.getPeriodText(this.period)
                // console.log(this.periodText)
                for (const room of Object.values(data.data[this.propertyid].rooms)) {
                  if (parseInt(room.occupancy.maximumTotalOccupancy) > maximumOccupancy) {
                    maximumOccupancy = room.occupancy.maximumTotalOccupancy
                  }
                  if (parseInt(room.occupancy.maximumTotalOccupancy) > maximumAdultOccupancy) {
                    maximumAdultOccupancy = room.occupancy.maximumTotalOccupancy
                  }
                }
                const maxNight = data.data[this.propertyid].maximum_nights
                if (parseInt(this.period) > parseInt(maxNight)) {
                  this.clicked = true
                  this.dataToggle = 'tooltip'
                  this.errMsg = 'Maximum (' + maxNight + ') nights exceeded'
                  this.$toast.error(this.errMsg)
                } else {
                  this.clicked = false
                }
                if (parseInt(this.period) < parseInt(maxNight) && (this.room >= 2 || parseInt(this.guest) > parseInt(maximumOccupancy) || parseInt(this.adult) > parseInt(maximumAdultOccupancy))) {
                  if (this.$route.path === '/multi-property' || this.$route.path === '/') {
                    this.$router.push({
                      path: '/multi-room-selection/?pid=' + btoa(this.propertyid)
                    })
                  }
                }
                this.bookings = data
                this.roomData = this.bookings.data[this.propertyid].rooms
                this.bookingData = this.bookings.data[this.propertyid]
                this.roomLabel = this.bookings.data[this.propertyid].room_label
                this.guestFormSettings =
                                        this.bookings.data[this.propertyid].guest_form_settings
                this.ageGroupsDetails =
                                        this.bookings.data[this.propertyid].age_group_details
                if (this.bookings.data[this.propertyid].rooms.length === 0) {
                  this.errors = true
                  this.errorMsg.push('No available rates')
                }
                for (const object of Object.values(
                  this.bookings.data[this.propertyid].rooms
                )) {
                  for (const board of Object.values(object.boards)) {
                    if (
                      board.roomPrice.res === 0 ||
                                                board.roomPrice.res === ''
                    ) {
                      this.residenceTab = true
                    }
                    if (
                      board.roomPrice.nonres === 0 ||
                                                board.roomPrice.nonres === ''
                    ) {
                      this.residenceTab = true
                    }
                  }
                }
                // console.log('[checkAvailabilty] currency.res:', this.bookings.data[this.propertyid].currency.res, '| currency.nonres:', this.bookings.data[this.propertyid].currency.nonres, '| residenceTab:', this.residenceTab)
                // console.log('[checkAvailabilty] ratePlanResidency:', this.ratePlanResidency, '| proofRes before currency block:', this.proofRes)
                if (
                  this.bookings.data[this.propertyid].currency.res !== '' &&
                                        this.bookings.data[this.propertyid].currency.nonres === ''
                ) {
                  // console.log('[checkAvailabilty] branch: ONLY RESIDENT rates available → proofRes=0')
                  this.proofRes = 0
                  this.residenceTab = true
                } else if (
                  this.bookings.data[this.propertyid].currency.res === '' &&
                                        this.bookings.data[this.propertyid].currency.nonres !== ''
                ) {
                  // console.log('[checkAvailabilty] branch: ONLY NON-RESIDENT rates available → proofRes=1')
                  this.proofRes = 1
                  this.residenceTab = true
                } else {
                  // ratePlanResidency from URL takes priority over property default
                  const defaultRes = this.ratePlanResidency ||
                    this.bookings.data[this.propertyid].guest_form_settings.default_residency
                  // console.log('[checkAvailabilty] branch: BOTH currencies available | defaultRes:', defaultRes, '(ratePlanResidency:', this.ratePlanResidency, ', property default:', this.bookings.data[this.propertyid].guest_form_settings.default_residency, ')')
                  if (defaultRes === 'res') {
                    this.resident = 'resident'
                    this.proofRes = 0
                    this.localResident()
                  } else if (defaultRes === 'nonres') {
                    this.resident = 'non-resident'
                    this.proofRes = 1
                    this.nonResident()
                  }
                }
                // console.log('[checkAvailabilty] proofRes after currency block:', this.proofRes)
                // ratePlanID residency always wins — force it after all currency checks
                if (this.ratePlanResidency === 'nonres') {
                  // console.log('[checkAvailabilty] ratePlanID override → forcing proofRes=1 (non-resident)')
                  this.proofRes = 1
                  this.resident = 'non-resident'
                  this.resNonRes = 'nonres'
                } else if (this.ratePlanResidency === 'res') {
                  // console.log('[checkAvailabilty] ratePlanID override → forcing proofRes=0 (resident)')
                  this.proofRes = 0
                  this.resident = 'resident'
                  this.resNonRes = 'res'
                }
                // console.log('[checkAvailabilty] FINAL proofRes:', this.proofRes, '| resident:', this.resident)
                const payload = {
                  bookingData: data,
                  stay_period: this.period,
                  babies: this.babies,
                  childAges: this.childAges
                }
                this.$store.dispatch('getBookingData', payload)
                this.$store.commit('updateLoyaltyIsEnabled', this.guestFormSettings.is_loyalty_enabled)
                this.$store.commit('updateGtmContainerId', this.guestFormSettings.gtm_container_id)
                this.isSearching = false
                this.loadResult = true
                // console.log('[checkAvailabilty] DONE | propertyid:', this.propertyid, '| destination:', this.destination, '| initialPropertyId:', this.initialPropertyId, '| initialPropertyName:', this.initialPropertyName)
                // console.log('[checkAvailabilty] DONE | multiproperties:', this.multiproperties.map(p => ({ id: p.id, name: p.propertyName })))
                // console.log('[checkAvailabilty] DONE | dropdown options will be: hardcoded={id:', this.initialPropertyId, ', name:', this.initialPropertyName, '} + loop=', this.multiproperties.filter(p => p.id !== this.initialPropertyId).map(p => p.id))
                this.getOffers(this.propertyid)
              } else {
                this.errors = true
                this.errorMsg.push('Failed to decrypte data')
              }
            }
          } catch (error) {
            if (type === 's') {
              document.getElementById('btn_close').click()
            }
          }
          this.isSearching = false
        } else {
          this.propertyerror = true
        }
      } else {
        this.$alert('Please Choose Destination.', '', 'warning')
      }
    },
    computeChildrenAgeRange (ageGroupsDetails) {
      var computedChildAges = []
      for (
        var i = parseInt(ageGroupsDetails.child_min_age); i <= parseInt(ageGroupsDetails.child_max_age); i++
      ) {
        computedChildAges.push({
          age: i
        })
      }

      return computedChildAges
    },
    getParameter (name) {
      const urlParams = new URLSearchParams(window.location.search)
      return urlParams.get(name)
    },
    // track the source for direct bookings
    getSource () {
      // checkinDay=23&checkinMonth=01&checkinYear=2024&nights=1&adults=2
      // all all the above are set, then this must be from google hotels
      const checkinDay = this.getParameter('checkinDay')
      const checkinMonth = this.getParameter('checkinMonth')
      const checkinYear = this.getParameter('checkinYear')
      if (checkinDay && checkinMonth && checkinYear) {
        this.$store.state.drbsource = 'DRB-GH'
      } else {
        this.$store.state.drbsource = 'DRB'
      }
    }
  },
  computed: {
    orderedRooms () {
      if (!this.bookingData || !this.bookingData.rooms) return []
      const rooms = Array.isArray(this.bookingData.rooms)
        ? [...this.bookingData.rooms]
        : Object.values(this.bookingData.rooms)
      if (!this.ratePlanRoomId) return rooms
      const target = String(this.ratePlanRoomId)
      return [...rooms].sort((a, b) => {
        if (String(a.id) === target) return -1
        if (String(b.id) === target) return 1
        return 0
      })
    },
    pageCount () {
      let l = this.allOffers.length
      let s = this.size
      return Math.ceil(l / s)
    },
    allOffers () {
      let generatedOffers = []
      var innerOffers = Object.values(this.offers)

      innerOffers.forEach((array) => {
        array.forEach((it) => {
          generatedOffers.push(it)
        })
      })
      return generatedOffers
    },
    paginatedData () {
      return this.allOffers.slice(
        (this.currentPage - 1) * this.size,
        this.currentPage * this.size
      )
    },
    totalPages () {
      return Math.ceil(this.allOffers.length / this.size)
    },
    ...mapState({
      checkinDate: state => state.checkinDate,
      checkoutDate: state => state.checkoutDate
    }),
    mobileCheckinLabel () {
      return this.checkinDate ? moment(this.checkinDate).format('ddd, D MMM') : 'Select date'
    },
    mobileCheckoutLabel () {
      return this.checkoutDate ? moment(this.checkoutDate).format('ddd, D MMM') : 'Select date'
    }
  },
  mounted () {
    // Mount onto a placeholder that's already attached to <body> (rather than
    // mounting detached and moving it afterwards) so every child component -
    // including the date-pickers, which measure their own position on mount -
    // sees accurate layout from the start instead of a 0x0 detached DOM.
    const mountEl = document.createElement('div')
    document.body.appendChild(mountEl)
    this.mobileSearchModal = new (Vue.extend(MobileSearchModal))({ parent: this }).$mount(mountEl)
  },
  beforeDestroy () {
    if (this.mobileSearchModal) {
      this.mobileSearchModal.$destroy()
    }
  },
  mixins: [reusableData]
}
</script>

<style>
@import "../assets/styles/main.css";

.swal2-content {
  font-size: 1.2rem!important;
}

.swal2-title {
  font-size: 1.7rem!important;
  font-weight: 700!important;
  margin: 0 0 1rem 0!important;
}

.swal2-icon {
  border: .3em solid transparent;
}

.swal2-icon::before {
  font-size: 4.5em;
}

.swal2-confirm {
  border-radius: 0!important;
  background-color: #ff573d!important;
}
</style>




// WEBPACK FOOTER //
// src/components/Booking.vue